import qs from 'qs'
import { axios } from '@/utils/request'

const workApi = {
  getExpertNumByGroup: '/api/1/workplace/getExpertNumByGroup',
  getWorkViewIndex: '/api/1/workplace/getWorkViewIndex',
  nearestExtractTaskList: '/api/1/workplace/nearestExtractTaskList',
}

/**
 * 获取专家数量
 * @param groupField 分组字段
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetExpertNumByGroup = (groupField) => axios.get(workApi.getExpertNumByGroup, { params: { groupField: groupField } })

/**
 * 获取工作台页面数据
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetWorkViewIndex = (page) => axios.get(workApi.getWorkViewIndex, { params: { ...page } })
/**
 * 最近工作列表
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const NearestExtractTaskList = (data) => axios.get(workApi.nearestExtractTaskList, { params: { ...data } })
